interface ISizeScope {
    max: number;
    min: number;
}
interface IScreenSizeType {
    [key: string]: ISizeScope;
}

// This file combine old rendition app-module.js part code and device-info-services.js part code
export const screenType = () => {
        const screenSizeType: IScreenSizeType = {
            extraLargeScreen: {
                max: 10000,
                min: 1263
            },
            largeScreen: {
                max: 1262,
                min: 1007
            },
            mediumScreen: {
                max: 1006,
                min: 751
            },
            smallScreen: {
                max: 750,
                min: 463
            },
            extraSmallScreen: {
                max: 462,
                min: 0
            },
        };

        let deviceScreen: string = '';

        Object.keys(screenSizeType).forEach((key) => {
            if (screenSizeType[key].min <= window.innerWidth && window.innerWidth <= screenSizeType[key].max){
                deviceScreen = key;
            }
        });

        return deviceScreen;
};

export const isDeviceScreenType = () => {
    return ( screenType() == 'smallScreen' || screenType() == 'extraSmallScreen');
};

export const isIE = () => {
    return Object.prototype.hasOwnProperty.call(window, 'ActiveXObject');
};

export const IEDocumentMode = () => {
    const target_window = (window.self !== window.top) ? window.parent : window;
    const ua = navigator.userAgent.toLowerCase();
    const match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
        /(webkit)[ \/]([\w.]+)/.exec(ua) ||
        /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
        /(msie) ([\w.]+)/.exec(ua) ||
        ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
        [];
    const browser_details = {
        browser: match[1] || "",
        version: match[2] || "0"
    };

    let mode = '';
    try {
        mode = target_window.document.documentMode ? target_window.document.documentMode : browser_details.version;
    }
    catch (e) {
        mode = window.document.documentMode ? window.document.documentMode : browser_details.version;
    }

    return parseInt(mode, 10); // 7.0->7 etc.
};
